import { io } from "socket.io-client";

//Events
export const USER_MESSAGE_AVAILABLE = "user message available";
export const DEDICATION_AS_USER = "dedication as user";
export const DEDICATION_TO_ROLE = "dedication to role";
export const DEDICATION_TO_USER = "dedication to user";
export const ORDER_DELETION = "order deletion";
export const ORDER_REQUEST_ASSIGNED = "order request assigned";
export const PAYMENT_COMPLETION = "payment completion";
export const PAYMENT_FAILURE = "payment failure";
export const DELIVERY_DRIVER_ASSIGNMENT = "delivery driver assignment";
export const DELIVERY_CONFIRMATION = "delivery confirmation";
export const TIME_FRAME_EXTENSION_REQUEST = "time-frame extension request";
export const TIME_FRAME_EXTENSION_APPROVAL = "time-frame extension approval";
export const RETRIEVAL_DRIVER_ASSIGNMENT = "retrieval driver assignment";
export const RETRIEVAL_CONFIRMATION = "retrieval confirmation";
export const NOTIFICATION_AVAILABLE = "notification available";

export const APP_UPDATE_AVAILABLE = "app update available";
export const SERVICE_PLAN_REQUESTED = "service plan requested";
export const SERVICE_PLAN_REQUEST = "service plan request";
export const SERVICE_PLAN_RENDERER_ASSIGNMENT =
  "service plan driver assignement";
export const SERVICE_PLAN_REQUEST_ASSIGNMENT = "service plan assignment";
export const SERVICE_PLAN_DELETION = "service plan deletion";
export const SERVICE_PLAN_APPROVAL = "service plan approval";
export const SERVICE_DISPATCH = "service dispatch";
export const SERVICE_RENDER = "service render";
export const SERVICE_PLAN_TERMINATION = "service plan termination";
export const SERVICE_PLAN_RESUMPTION = "service plan resumption";
export const SERVICE_PLAN_COMPLETION = "service plan completion";
export const SERVICE_PLAN_PERIOD_ENDED = "service plan period over";
export const SERVICE_PLAN_PERIOD_BILLING = "service plan period billing";

const serverEndpoint: string = process.env.REACT_APP_SERVER_ENDPOINT as string;
const socket = io(serverEndpoint, {
  autoConnect: false,
});

socket.connect();

export default socket;
